module.exports = __webpack_public_path__ + "img/transparent_javascript.a935cbd9.png";